import axios from "api/config/axiosConfig";
import { Theme } from "api/config/chalice-types";

export const fetchThemes = async () => {
  const response = await axios.get<Theme[]>("/themes?approved=true");
  return response.data;
};

export const getTheme = async (themeId: string) => {
  const response = await axios.get<Theme>(`/themes/${themeId}`);
  return response.data;
};
